import React from 'react';
import './Hero.css'

const Hero = () => {
    return (
        <div className='hero-section'>
            <h2 className='hero-title'>Life is a journey, not a destination</h2>
        </div>
    );
};

export default Hero;